import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.daily.tripple_deposit,
    (task) => {
        return {
            task
        }
    }
)